(() => {
  const normalizePorchetCopy = (copy) =>
    copy
      .replace(/18 ?CT/g, '750‰')
      .replace(
        /(\d+(?:[.,]\d+)?\s*[-–]\s*\d+(?:[.,]\d+)?)(?:\s*(?:MM|M))\b/gi,
        '$1 MM'
      )
      .replace(
        /(\d+(?:[.,]\d+)?\s*[-–]\s*\d+(?:[.,]\d+)?)(?=\s+(?:\d+G\d+|D\d|S\d))/g,
        '$1 MM'
      );

  const normalizeTextNodes = (root) => {
    const textNodes = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        const tagName = node.parentElement?.tagName;
        return ['SCRIPT', 'STYLE', 'TEXTAREA', 'TEMPLATE'].includes(tagName)
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      },
    });
    const nodes = [];
    let node;

    while ((node = textNodes.nextNode())) nodes.push(node);

    nodes.forEach((textNode) => {
      const normalizedText = normalizePorchetCopy(textNode.nodeValue);
      if (normalizedText !== textNode.nodeValue) textNode.nodeValue = normalizedText;
    });
  };

  const normalizeTitles = () => {
    normalizeTextNodes(document.body);
    document.title = normalizePorchetCopy(document.title);

    document
      .querySelectorAll('meta[name="description"], meta[property^="og:"], meta[name^="twitter:"]')
      .forEach((meta) => {
        const content = meta.getAttribute('content');
        if (content) meta.setAttribute('content', normalizePorchetCopy(content));
      });
  };

  let queued = false;
  const scheduleNormalization = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      normalizeTitles();
    });
  };

  normalizeTitles();
  new MutationObserver(scheduleNormalization).observe(document.body, { childList: true, subtree: true });
})();
